<template>
<div id="app">
    <v-app>
      <v-main>
        <app-header />
        <v-container id="container">
          <router-view></router-view>
        </v-container>
        <app-footer />
      </v-main>
    </v-app>
</div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  components: { AppHeader, AppFooter },
  name: "app",
}
</script>

<style scoped lang="scss">
#app {
    font-family: 'Open Sans', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*   margin-top: 60px;
 */

    display: -webkit-box;
    /* OLD - iOS 6-, Safari 3.1-6, BB7 */
    display: -ms-flexbox;
    /* TWEENER - IE 10 */
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.html {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
}

#container {
  padding-bottom: 7.5rem;
}

.content-container {
    flex: 1 0 auto;
}

.alert {
    position: fixed;
    top: 1rem;
    left: 2%;
    width: 96%;
    z-index: 9999;
    border-radius: 5px
}

@import url('https://fonts.googleapis.com/css?family=Unica+One&display=swap');

@import url(https://fonts.googleapis.com/css?family=Roboto:400,300,500);

body {
    margin: 0 auto;
    width: 100%;
    /*max-width: 1240px;*/
    font-family: 'Unica One', sans-serif;
    letter-spacing: .1em;
    text-transform: uppercase;
    position: relative;
    min-height: 100%;
    background-color: #f6f6f6;
}

/* Classes automatically wrapped in a vue transition */
.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: opacity .1s;
}

.fade-leave {
    opacity: 1;
}

.fade-leave-active {
    transition: opacity .75s;
    opacity: 0;
}
</style>

<style scoped>
</style>
